<template>
  <div>
    <CRow>
      <CCol sm="12">
        <span style="float: right; text-align: right;">
          {{student.customer_name}}<br/>{{student.customer_phone}}<br /><br />
          <CButton color="info" size="sm" @click="showTravel(student.travel_id)">Volver al Viaje</CButton>
        </span>
        <h1>{{student.name}}</h1>
        <br />

        <CNav variant="tabs" role="tablist">
          <li class="nav-item" :class="tab === 'information' ? 'tab_active' : ''"><a href="#" target="_self" class="nav-link" @click="changeTab('information')"><CLink href="javascript:void(0);" :active="tab === 'information'"> Información </CLink></a></li>
          <li class="nav-item" :class="tab === 'payments' ? 'tab_active' : ''"><a href="#" target="_self" class="nav-link" @click="changeTab('payments')"><CLink href="javascript:void(0);" :active="tab === 'payments'"> Pagos </CLink></a></li>
        </CNav>
        <CTabs class="remove">
          <CTab role="tabpanel" aria-labelledby="information-tab" v-if="tab === 'information'">
            <StudentQuestionsTable
              hover
              striped
              border
              small
              fixed
              caption="Pagos del Alumno"
              :id="id"
              type="student"
              :student="student"
              :travel="travel"
              ref="studentQuestionTable"
            />

            <CCard>
              <CCardHeader>
                Datos de Madre/Padre/Tutor
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol md="4">
                    <strong>Nombre (customers)</strong><br />
                    <span>{{parent.customer_name || 'N/D'}}</span>
                  </CCol>
                  <CCol md="4">
                    <strong>Correo (customers)</strong><br />
                    <span>{{parent.customer_email || 'N/D'}}</span>
                  </CCol>
                  <CCol md="4">
                    <strong>Correo (users)</strong><br />
                    <span>{{parent.user_email || 'N/D'}}</span>
                    <span v-if="parent.customer_email && parent.user_email && parent.customer_email != parent.user_email" style="display: block; color: #b45309; font-size: 12px;">No coincide con customers</span>
                  </CCol>
                </CRow>
                <CRow class="mt-3">
                  <CCol md="4">
                    <strong>Contraseña (users)</strong><br />
                    <span>{{parent.password || 'N/D'}}</span>
                  </CCol>
                  <CCol md="4">
                    <strong>Último login</strong><br />
                    <span>{{formatDateTime(parent.last_login)}}</span>
                  </CCol>
                  <CCol md="4" class="text-right">
                    <CButton color="warning" size="sm" style="margin-right: 8px;" @click="openEditParentModal">Editar Datos</CButton>
                    <CButton color="info" size="sm" @click="openWelcomePreviewModal">Enviar Bienvenida</CButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab role="tabpanel" aria-labelledby="payments-tab" v-if="tab === 'payments'">
            <StudentPaymentsTable
                hover
                striped
                border
                small
                fixed
                caption="Pagos del Alumno"
                :id="id"
                type="student"
                :student="student"
                :travel="travel"
              />
          </CTab>
        </CTabs>

        <CModal title="Editar Datos del Tutor" color="warning" :show.sync="showParentModal">
          <CForm>
            <CRow>
              <CCol md="12">
                <CInput label="Nombre (customers/users)" v-model="parentForm.name" />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput label="Correo (customers/users)" type="email" v-model="parentForm.email" />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput label="Contraseña (users)" v-model="parentForm.password" />
              </CCol>
            </CRow>
          </CForm>
          <template #footer>
            <CButton color="secondary" @click="showParentModal = false">Cancelar</CButton>
            <CButton color="warning" @click="saveParentData">Guardar</CButton>
          </template>
        </CModal>

        <CModal title="Previsualización: Correo de Bienvenida" color="info" :show.sync="showWelcomePreviewModal" size="lg">
          <div>
            <p><strong>Para:</strong> {{parent.customer_email || 'N/D'}}</p>
            <p><strong>Asunto:</strong> Bienvenido!! Has completado tu registro al viaje {{travel && travel.name ? travel.name : ''}}</p>
            <hr />
            <p><strong>Alumno:</strong> {{student.name || 'N/D'}}</p>
            <p><strong>Tutor:</strong> {{parent.customer_name || 'N/D'}}</p>
            <p><strong>Correo de acceso:</strong> {{parent.user_email || parent.customer_email || 'N/D'}}</p>
            <p><strong>Contraseña:</strong> {{parent.password || 'N/D'}}</p>
            <p style="font-size: 12px; color: #666;">Se enviará el correo de bienvenida existente con la información actual del registro.</p>
          </div>
          <template #footer>
            <CButton color="secondary" @click="showWelcomePreviewModal = false">Cancelar</CButton>
            <CButton color="info" @click="sendWelcomeEmail">Enviar Correo</CButton>
          </template>
        </CModal>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import StudentQuestionsTable from '../../components/travels/students/StudentQuestionsTable.vue'
import StudentPaymentsTable from '../../components/travels/payments/StudentPaymentsTable.vue'
import travels from '../../services/travels';
import students from '../../services/students';
import users from '../../services/users';
import store from '../../store'
import moment from 'moment';

export default {
  name: 'Student',
  components: { StudentPaymentsTable, StudentQuestionsTable },
  data: function () {
		return {
            tab: 'information',
            travel: false,
            student: false,
            parent: {
              customer_name: '',
              customer_email: '',
              user_email: '',
              password: '',
              last_login: null,
            },
            parentForm: {
              name: '',
              email: '',
              password: '',
            },
            showParentModal: false,
            showWelcomePreviewModal: false,
            payments: [],
            id: 0
        }
  },
  mounted: async function() {
    this.loading();

    this.id = await this.$route.params.id;

    await this.loadStudent();

    this.changeTab("information")

    this.loaded();
  },
  methods: {
    async loadStudent() {
      let response = await students.showById(this.id);

      if(response.type == "success"){
        this.student = response.data;
        this.parent = response.data.parent_info || this.parent;
      }

      let response2 = await travels.showById(this.student.travel_id);

      if(response2.type == "success"){
        this.travel = response2.data;
      }
    },
    openEditParentModal() {
      this.parentForm = {
        name: this.parent.customer_name || '',
        email: this.parent.customer_email || this.parent.user_email || '',
        password: this.parent.password || '',
      }
      this.showParentModal = true;
    },
    async saveParentData() {
      if(!this.parentForm.name || !this.parentForm.email){
        store.commit('toast', {color: 'warning', message: 'Nombre y correo son obligatorios.'});
        return;
      }

      this.loading();
      const response = await users.updateByStudent({
        id: this.student.id,
        student_id: this.student.id,
        name: this.parentForm.name,
        email: this.parentForm.email,
        password: this.parentForm.password,
      });

      this.showParentModal = false;
      this.showToast(response.type, response.message);

      if(response.type == 'success'){
        await this.loadStudent();
      }

      this.loaded();
    },
    openWelcomePreviewModal() {
      this.showWelcomePreviewModal = true;
    },
    async sendWelcomeEmail() {
      this.loading();
      const response = await travels.sendWelcomeMessage({student_id: this.student.id});
      this.showWelcomePreviewModal = false;
      this.showToast(response.type, response.message + ' (' + (this.parent.customer_email || '').toLowerCase() + ')');
      this.loaded();
    },
    formatDateTime(value) {
      if(!value){
        return 'Nunca ha iniciado sesión';
      }

      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    async changeTab(tab){
      this.loading();
      this.tab = tab;

      this.loaded();
    },
    showTravel (travel_id) {
      this.$router.push({path: '/travels/'+travel_id+'/show'})
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
<style>
.remove .nav.nav-tabs{
  display: none;
}
</style>